/* eslint-disable */

export default function() {
  location.href = 'https://ixanos.co.tt/';
}